import SessionEventProto from "../session-event-proto";
import ExpenseFields from "../../model2/expenses/expense/fields";

export default class SessionEvent_CompanyDelta extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {

        // this.data
        const sessionCompany = gd.session.companies.get(this.data.id)
        if (!sessionCompany) return false

        // keys
        // financeCurrency financeDefaultInternalCost financeDefaultExternalCost
        // are ignored as not part of company.session ...

        if (_.has(this.data, 'finance')) {
            sessionCompany.finance = this.data.finance
            // console.log("session update applied with ", this.data.finance)
        }

        if (_.has(this.data, 'financeCurrency')) {
            sessionCompany.financeCurrency = this.data.financeCurrency
            gd.fields.resetCurrencyFields()
        }

        if (_.has(this.data, 'financeDefaultInternalCost')) {
            sessionCompany.financeDefaultInternalCost = this.data.financeDefaultInternalCost
        }

        if (_.has(this.data, 'financeDefaultExternalCost')) {
            sessionCompany.financeDefaultExternalCost = this.data.financeDefaultExternalCost
        }

    }
};
